import { useEffect } from 'react'

const APP_NAME = 'Ponto Ágil'

/**
 * Hook para definir o título da página do navegador
 * @param title - Título da página
 */
export function usePageTitle(title: string | undefined) {
    useEffect(() => {
        if (!title) return

        const previousTitle = document.title
        document.title = title ? `${title} - ${APP_NAME}` : APP_NAME

        return () => {
            document.title = previousTitle
        }
    }, [title])
}
